import { motion } from "framer-motion";

const steps = [
  {
    number: "01",
    title: "Start a session on your Mac",
    description: "Run Claude Code, Codex CLI, or another terminal workflow. Runzr wraps the session and tracks its lifecycle.",
    detail: "$ runzr start 'claude-code --task refactor auth'",
  },
  {
    number: "02",
    title: "Get notified when something happens",
    description: "Runzr detects completion, failure, or approval checkpoints and sends a push notification to your phone.",
    detail: "Agent requires permission to execute npm install",
  },
  {
    number: "03",
    title: "Respond from your phone",
    description: "Open the app, view live output, and approve, stop, or message the session. No SSH, no remote desktop.",
    detail: "Tap Approve to continue the session remotely",
  },
];

export default function HowItWorksSection() {
  return (
    <section
      data-testid="how-it-works-section"
      className="py-24 px-6"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span
            className="text-xs uppercase tracking-wider mb-4 block"
            style={{
              color: "#A1A1AA",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "11px",
            }}
          >
            How it works
          </span>
          <h2
            className="text-3xl sm:text-4xl font-semibold tracking-tight text-white"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Three steps. Full control.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, i) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="relative p-8 rounded-xl"
              style={{
                background: "rgba(255,255,255,0.02)",
                border: "1px solid rgba(255,255,255,0.06)",
              }}
            >
              <span
                className="text-4xl font-bold mb-6 block"
                style={{
                  color: "rgba(255,255,255,0.06)",
                  fontFamily: "'Outfit', sans-serif",
                }}
              >
                {step.number}
              </span>
              <h3
                className="text-lg font-medium text-white mb-3"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {step.title}
              </h3>
              <p className="text-sm leading-relaxed mb-4" style={{ color: "#A1A1AA" }}>
                {step.description}
              </p>
              <div
                className="px-3 py-2 rounded-lg text-xs"
                style={{
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.06)",
                  color: "#71717A",
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: "11px",
                }}
              >
                {step.detail}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
